import { render, staticRenderFns } from "./CreateCategoriesBlogPage.vue?vue&type=template&id=b94a4c06&scoped=true&"
import script from "./CreateCategoriesBlogPage.vue?vue&type=script&lang=js&"
export * from "./CreateCategoriesBlogPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateCategoriesBlogPage.vue?vue&type=style&index=0&id=b94a4c06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94a4c06",
  null
  
)

export default component.exports